
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import CatalogueSelectControl from "@/components/controls/base/CatalogueSelectControl.vue";

export default defineComponent({
  components: {
    CreateEditDialog,
    CatalogueSelectControl,
  },
  props: {
    saveModelCallback: { required: true },
  },
  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
  data() {
    return {};
  },
});
